
export const areArraysDifferent = (initial, changed, key) => {
    if (initial.length !== changed.length) return true;
    for (let a = 0; a < changed.length; a++) {
        if (!initial.some((i) => i[key] === changed[a][key])) return true;
        }
    return false;
    };